import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function PageGuideCard({
  onboarding,
  guideKey,
  title,
  description,
  ctaLabel,
  ctaHref,
  onDismiss,
}) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(false);
  }, [guideKey, title]);

  const dismissedPages = Array.isArray(onboarding?.onboarding_dismissed_pages)
    ? onboarding.onboarding_dismissed_pages
    : [];
  const isDismissedForPage = guideKey
    ? dismissedPages.includes(guideKey)
    : false;

  if (
    !onboarding ||
    onboarding.onboarding_completed ||
    isDismissedForPage ||
    dismissed
  ) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    onDismiss?.();
  };

  return (
    <section className="mb-6 rounded-[1.6rem] border border-blue-100 bg-gradient-to-br from-blue-50 via-white to-sky-50 p-5 shadow-sm dark:border-blue-900/40 dark:from-gray-900 dark:via-gray-900 dark:to-slate-900">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="max-w-2xl">
          <p className="type-eyebrow mb-2">Welcome To CartNom</p>
          <h2 className="type-section-title">{title}</h2>
          <p className="type-muted mt-2">{description}</p>
          {ctaLabel && ctaHref && (
            <Link
              to={ctaHref}
              className="mt-4 inline-flex items-center text-sm font-medium text-blue-600 transition hover:text-blue-700 dark:text-blue-300 dark:hover:text-blue-200"
            >
              {ctaLabel}
            </Link>
          )}
        </div>

        <button
          type="button"
          onClick={handleDismiss}
          className="shrink-0 text-sm font-medium text-slate-400 transition hover:text-slate-600 dark:hover:text-slate-200"
        >
          Dismiss
        </button>
      </div>
    </section>
  );
}
